import { render } from "./competition_completed.vue?vue&type=template&id=64cf2edb&scoped=true"
import script from "./competition_completed.vue?vue&type=script&lang=js"
export * from "./competition_completed.vue?vue&type=script&lang=js"

import "./competition_completed.vue?vue&type=style&index=0&id=64cf2edb&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cf2edb"]])

export default __exports__